import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsCustomerGeneralInfo } from 'common/customers/services/types/RsCustomerGeneralInfo';
import { CustomerUpdateGeneral } from 'common/customers/services/types/CustomerUpdateGeneral';

export type ICustomerGeneralDataProvider = IDataProviderV2<{}, RsCustomerGeneralInfo, {}, CustomerUpdateGeneral>;

@A9Service('customerGeneralDataProvider')
export class CustomerGeneralDataProvider extends AbstractDataProviderV2<{}, RsCustomerGeneralInfo, {}, CustomerUpdateGeneral> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{id}/general');
    }

    public list(): Promise<any> {
        return Promise.reject('Method is not supported');
    }

    public add(): Promise<any> {
        return Promise.reject('Method is not supported');
    }

    public patch(): Promise<any> {
        return Promise.reject('Method is not supported');
    }

    public remove(): Promise<any> {
        return Promise.reject('Method is not supported');
    }
}
